import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { PrimaryButtonComponent } from './components/primary-button/primary-button.component';
import {
  HeaderComponent,
  HelpComponent,
  AuthVideoPipe,
} from './components/header/header.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material Modules
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderComponent } from './components/loader/loader.component';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { MatSliderModule } from '@angular/material/slider';
import { ValueSetterComponent } from './components/value-setter/value-setter.component';
import { NotificationListComponent } from './components/notification/notification.component';
import { NotificationService } from './services/notification.service';
import { HttpErrorInterceptor } from './interceptors/http-error-interceptor';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { LoaderService } from './services/loader.service';
import { SessionStorageService } from './services/session-storage.service';
import { LocalStorageService } from './services/local-storage.service';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CardButtonComponent } from './components/card-button/card-button.component';
import { SingleRangeComponent } from './components/single-range/single-range.component';
import { ImpactItemComponent } from './components/impact-item/impact-item.component';
import { DollarPipe } from './filters/dollar-pipe';
import { CamelCasePipe } from './filters/camelcase-pipe';
import { SpacePipe } from './filters/space-pipe';
import { PercentPipe } from './filters/percent-pipe';
import { PercentSign } from './filters/percent-sign';
import { ThousandSuffixesPipe } from './filters/thousandsuff-pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthService } from './services/auth.service';
import { NumberSuffixPipe } from './filters/numberSuffix-pipe';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ChartService } from './services/waterfallChart.service';
import { LowerBound } from './services/lowerBound.service';
import { FeedbackPopupDialog } from './components/feedback-popup/feedback-popup.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { KeycloakBearerInterceptor, KeycloakService } from 'keycloak-angular';
import { suffixConditionalPipe } from './filters/suffixConditional';
import { Sort } from './services/sort';
import { suffixConditionalWithDollarPipe } from './filters/suffixConditionalwithDollar';
import { SuffixCammasPipe } from './filters/suffix-cammas.pipe';
@NgModule({
  declarations: [
    PrimaryButtonComponent,
    HeaderComponent,
    HelpComponent,
    NavbarComponent,
    LoaderComponent,
    IconButtonComponent,
    ValueSetterComponent,
    NotificationListComponent,
    CardButtonComponent,
    SingleRangeComponent,
    ImpactItemComponent,
    DollarPipe,
    CamelCasePipe,
    NumberSuffixPipe,
    SpacePipe,
    AuthVideoPipe,
    PercentPipe,
    PercentSign,
    ThousandSuffixesPipe,
    FeedbackPopupDialog,
    suffixConditionalPipe,
    suffixConditionalWithDollarPipe,
    SuffixCammasPipe,
  ],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    RouterModule,
    FlexLayoutModule,
    HttpClientModule,
    MatButtonModule,
    MatSliderModule,
    FormsModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatDialogModule,
    MatSidenavModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatButtonModule,
    MatInputModule,
  ],
  exports: [
    PrimaryButtonComponent,
    HeaderComponent,
    NavbarComponent,
    LoaderComponent,
    IconButtonComponent,
    ValueSetterComponent,
    NotificationListComponent,
    CardButtonComponent,
    SingleRangeComponent,
    ImpactItemComponent,
    DollarPipe,
    CamelCasePipe,
    NumberSuffixPipe,
    SpacePipe,
    PercentPipe,
    PercentSign,
    ThousandSuffixesPipe,
    suffixConditionalPipe,
    suffixConditionalWithDollarPipe,
    SuffixCammasPipe,

  ],
  providers: [
    NotificationService,
    AuthService,
    ChartService,
    LowerBound,
    Sort,
    CurrencyPipe,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
      deps: [
        NotificationService,
        LoaderService,
        SessionStorageService,
        LocalStorageService,
        AuthService,
      ],
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {}
